import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import JsonScreen from "../../../../JsonScreen/JsonScreen";
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import FormField from "../../../../../Utils/Form/Fields/FormField";
import JsonEditor from "./DataSourceForm/JsonEditor";
import request from "../../../../../Services/API/Requests";
import {useActions} from "../../../../../app/doActions";
import {getSafe} from "../../../../JsonScreen/Utils";
import {useSnackbar} from "notistack";

const useStyles = makeStyles(() => ({
    table: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        width: '105px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    text: {
        padding: '1px 8px 1px 3px',
        justifyContent: 'left',
        color: 'black'
    },
}));

const DataSource = (props) => {
    const {data: {source, id}, data, dataSourceChange, dataSourceSetConnection} = props;
    const {doActions, onChangeFields} = useActions({
        cancel: () => setIsOpen(false)
    });
    const [isOpen, setIsOpen] = useState(false);
    const [haveQuery, setHaveQuery] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    useEffect(() => {
        if (source.inPlaceConnection) {
            const currentConnector = source.inPlaceConnection.connector;

            async function getConnector() {
                const response = await request({
                    url: "connector/read",
                    method: "POST",
                    data: {id: currentConnector}
                });
                setHaveQuery(Boolean(response.haveQuery))
            }

            getConnector();
        }
    }, [JSON.stringify(source.inPlaceConnection)]);

    async function returnValue(data) {
        try {
            const isExists = await checkDataSource(id);
            const res = await request({
                url: `/dataSource/${isExists ? 'update' : 'create'}`,
                data: {
                    id,
                    ...source,
                    ...data
                },
            })
            dataSourceSetConnection(res);
            setIsOpen(false)
        } catch (err) {
            if (err.data !== undefined) {
                let errors = getSafe(() => err.data.status.message, []);
                errors.map(e => {
                    return enqueueSnackbar(e.text, {variant: e.type});
                });
            } else {
                enqueueSnackbar('Data Source save error', {variant: 'error'});
            }
        }
    }

    const classes = useStyles();
    return (
        <>
            <table className={classes.table}>
                <tbody>
                <tr>
                    <td className={classes.tableCellLabel}>Source Setup</td>
                    <td className={classes.tableCell}>
                        <Button
                            color="primary"
                            disabled={!id}
                            classes={{text: classes.text}}
                            fullWidth
                            onClick={() => setIsOpen(true)}
                        >
                            Edit Connection
                        </Button>
                    </td>
                </tr>
                <DataSourceAdditionalFields
                    data={data}
                    dataSourceChange={dataSourceChange}
                    haveQuery={haveQuery}
                />
                </tbody>
            </table>
            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <JsonScreen match={{params: {name: "dataSourceSetup"}}}
                            isPopUp={true}
                            closePopUp={() => setIsOpen(false)}
                            doActions={doActions}
                            onChangeFields={onChangeFields}
                            returnValue={returnValue}
                            location={{
                                state: {
                                    inParam: {
                                        dataSourceSetup: source || {}
                                    }
                                }
                            }}
                />
            </Dialog>
        </>
    )
};

export default ListDesignerHoc(DataSource)

const DataSourceAdditionalFields = (props) => {
    const [open, setOpen] = useState(false);
    const {data, dataSourceChange, haveQuery} = props;
    const classes = useStyles();
    return (
        <>
            <tr>
                <td className={classes.tableCellLabel}>Paged</td>
                <td className={classes.tableCell}>
                    <FormField
                        field={{
                            name: 'paged',
                            type: 'switch'
                        }}
                        onChange={dataSourceChange}
                        path={'source.paged'}
                        values={data}
                    />
                </td>
            </tr>
            {haveQuery && (
                <tr>
                    <td className={classes.tableCellLabel}>Query</td>
                    <td className={classes.tableCell}>
                        <Button
                            color="primary"
                            classes={{text: classes.text}}
                            fullWidth
                            onClick={() => setOpen(true)}
                        >
                            Edit Query
                        </Button>
                        <JsonEditor
                            open={open}
                            onClose={() => setOpen(false)}
                            values={data}
                        />
                    </td>
                </tr>
            )}
        </>
    )
};

DataSourceAdditionalFields.propTypes = {
    data: PropTypes.object,
    dataSourceChange: PropTypes.func,
    hasQuery: PropTypes.bool
};

export async function checkDataSource(id) {
    try {
        return await request({
            url: "/dataSource/read",
            data: {id}
        });
    } catch (e) {
        return null;
    }
}